import { Box, Flex } from '@chakra-ui/react';
import type { User } from '@halo/chat-sdk';
import { Avatar } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

interface MessageForwardFromProps {
  user: User | undefined;
  onAvatarClick?: (userId: string) => void;
}

function MessageForwardFrom({ user, onAvatarClick }: MessageForwardFromProps) {
  const { t } = useTranslation();
  if (!user) {
    return null;
  }

  return (
    <Flex
      gap="1"
      pb="0.5"
      alignItems="center"
      fontSize="xs"
      fontWeight="medium"
      color="brand.100"
    >
      <Box flex="0 0 auto">{t('chat.forwardedFrom')}</Box>
      <Avatar
        flex="0 0 auto"
        src={user.avatar}
        onClick={() => onAvatarClick?.(user.user_id)}
        w="18px"
        h="18px"
      />
      <Box flex="1 1 auto" truncate>
        {user.name}
      </Box>
    </Flex>
  );
}

const MemoizedMessageForwardFrom = memo(MessageForwardFrom);
export { MemoizedMessageForwardFrom as MessageForwardFrom };
